import React from 'react';
import { Link } from 'react-router-dom';
import { Lightning } from '@phosphor-icons/react';

export const LowCreditBanner = ({ credits, tier }) => {
  if (!credits || credits.total > 5 || tier === 'starter') return null;

  const isZero = credits.total === 0;

  return (
    <div
      data-testid="low-credit-banner"
      className={`flex items-center justify-between px-4 py-2.5 rounded-xl mb-4 ${
        isZero
          ? 'bg-red-500/10 border border-red-500/20'
          : 'bg-amber-500/10 border border-amber-500/20'
      }`}
    >
      <div className="flex items-center gap-2">
        <Lightning size={16} weight="fill" className={isZero ? 'text-red-400' : 'text-amber-400'} />
        <p className="text-sm text-zinc-300">
          {isZero
            ? "You're out of media credits — don't get interrupted"
            : `You're running low on credits (${credits.total} left) — don't get interrupted`
          }
        </p>
      </div>
      <Link
        to="/dashboard/billing"
        data-testid="low-credit-banner-cta"
        className={`text-xs font-medium px-3 py-1.5 rounded-full transition-colors shrink-0 ${
          isZero
            ? 'bg-red-500/20 text-red-300 hover:bg-red-500/30'
            : 'bg-amber-500/20 text-amber-300 hover:bg-amber-500/30'
        }`}
      >
        Get more
      </Link>
    </div>
  );
};

export default LowCreditBanner;
